/** CANNAC brand tokens — material laws for UI and 3D. */
export const tokens = {
  ink: "#080b09",
  inkMid: "#0e1411",
  fog: "#dce5de",
  fogDim: "rgba(220, 229, 222, 0.55)",
  leaf: "#3ecf7a",
  leafSoft: "rgba(62, 207, 122, 0.12)",
  leafMid: "#279759",
  mint: "#d1f9df",
  /** Club cannac surfaces */
  velvet: "#0a1f18",
  brass: "#c9a227",
  brassSoft: "rgba(201, 162, 39, 0.22)",
  paper: "#f3ead7",
  paperInk: "#1a1612",
  paperMuted: "rgba(26, 22, 18, 0.62)",
} as const;

export const fonts = {
  display: '"Bricolage Grotesque", sans-serif',
  club: '"Syne", sans-serif',
  mono: '"IBM Plex Mono", monospace',
} as const;
